export const LOCATION_CHANGE_REGISTER = "LOCATION_CHANGE_REGISTER";
export const REQUEST_REGISTER = "REQUEST_REGISTER";
export const REGISTER_KICKED = "REGISTER_KICKED";
